import { type FC, useContext } from "react";
import { createBorderStyles } from "../../Forms/DragDrop/BorderSettingsDialog";
import { DragDropComponentEmptyContext, DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { createStyleFromPadding } from "../../Forms/PaddingInput";

export interface HeadingValueType {
    completed: string;
    parked: string;
}

export function isHeadingValue(value: unknown): value is HeadingValueType {
    if(typeof value !== "object") {
        return false;
    }

    if(value === null) {
        return false;
    }

    return "completed" in value && typeof value.completed === "string" &&
        "parked" in value && typeof value.parked === "string";
}

export const ReceiptHeadingComponent: FC<ComponentOptions> = ({ style, value }) => {
    const { padding, border, fontSize, ...styleRest } = style;

    const { status: data } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);
    const empty = useContext(DragDropComponentEmptyContext);

    if(!isHeadingValue(value)) {
        return error;
    }

    if(typeof data !== "string") {
        return error;
    }

    const status = data.toLowerCase();

    let content = "TRAINING MODE RECEIPT";

    if(status !== "training") {
        if(status === "incomplete") {
            content = value.completed;
        } else {
            content = value[status as keyof HeadingValueType];
        }
    }

    if(!content) {
        return empty;
    }

    return (
        <div
            className="receipt-heading"
            style={{
                width   : "100%",
                ...styleRest,
                ...(padding ? createStyleFromPadding(padding) : {}),
                ...(border ? createBorderStyles(border) : {}),
                fontSize: fontSize ? `${style.fontSize}px` : undefined,
            }}
        >
            {content}
        </div>
    );
};
